import React from 'react';
import SearchOffIcon from '@mui/icons-material/SearchOff';

const NoSearchResults = ({
  title = 'No matching notes found',
  message = 'Try adjusting your search terms',
}) => {
  return (
    <div className="no-search-results">
      <div className="no-results-icon">
        <SearchOffIcon sx={{ fontSize: 64, color: '#bdbdbd' }} />
      </div>
      <h3 className="no-results-title">{title}</h3>
      <p className="no-results-text">{message}</p>
    </div>
  );
};

export default NoSearchResults;
